import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { WFLocationOrderingEnum, WirtschaftsFoerderungService } from '@ui/shared/util-api';
import { toRequestQuery } from '@ui/shared/util-filter';
import { EconomicDevelopmentMapItem } from '../../definitions/economic-development-map-item';
import type { EconomicDevelopmentFilter } from '../../types/economic-development-filter';

@Injectable({ providedIn: 'root' })
export class EconomicDevelopmentMapDataService extends MapDataService<EconomicDevelopmentMapItem, EconomicDevelopmentFilter> {
    protected _api = inject(WirtschaftsFoerderungService);

    public getData$(filter: EconomicDevelopmentFilter): Observable<Array<EconomicDevelopmentMapItem>> {
        return this._api.getAllWfLocations({
            nameContains: typeof filter.search === 'string' ? filter.search : null,
            districtIds: toRequestQuery(filter.districtIds),
            typeIds: toRequestQuery(filter.categoryIds),
            industryIds: toRequestQuery(filter.industryIds),
            order: [WFLocationOrderingEnum.Name],
        })
            .pipe(map(response => response.data.map(dto => new EconomicDevelopmentMapItem(dto))));
    }
}
